import { useState } from "react";
import {
  createChart,
  getCharts,
  getSpecificChart,
  deleteChart,
  updateTheChart,
} from "../services/chartsService";

export const useCharts = () => {
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getAvailableCharts = async () => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await getCharts();
      setIsLoading(false);
      return response;
    } catch (error) {
      setError(true);
      setIsLoading(false); // Ensure loading state is reset
      return "Something went wrong while getting charts";
    }
  };

  const getOneChart = async (chartId) => {
    setIsLoading(true); // Ensure loading state is set
    setError(false);

    try {
      const response = await getSpecificChart(chartId);
      setIsLoading(false); // Ensure loading state is reset
      return response;
    } catch (error) {
      setError(true);
      setIsLoading(false); // Ensure loading state is reset
      return "Something went wrong";
    }
  };

  const createAChart = async (chartData) => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await createChart(chartData);
      setIsLoading(false);
      return response;
    } catch (error) {
      setError(true);
      setIsLoading(false); // Ensure loading state is reset
      return "Something went wrong while creating chart";
    }
  };

  const deleteAChart = async (chartID) => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await deleteChart(chartID);
      setIsLoading(false); // Ensure loading state is reset
      if (response) {
        return response;
      } else {
        return false;
      }
    } catch (error) {
      setError(true); // Ensure error state is set
      setIsLoading(false); // Ensure loading state is reset
      return false;
    }
  };

  const updateChart = async (chartId, updateData) => {
    setIsLoading(true);
    setError(false);
    try {
      const response = await updateTheChart(chartId, updateData);
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong while updating table using table ID";
    }
  };

  return {
    getAvailableCharts,
    createAChart,
    getOneChart,
    deleteAChart,
    updateChart,
    error,
    isLoading,
  };
};
